import { createRoomAsyncResponse } from "./types";
import * as roomActions from "./rooms.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPost, API_URL_ROOM, retrieveToken } from "../../../helpers/api";

export function* createRoom(action: ReturnType<typeof roomActions.createRoomAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiPost, API_URL_ROOM.CREATE_ROOM, token, action.payload);
    if (result.status === 200) {
      const parsed: createRoomAsyncResponse = yield call(result.json.bind(result));
      yield put(roomActions.createRoomAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roomActions.createRoomAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roomActions.createRoomAsync.failure(parsed));
  }
}

export default function* roomsSagaCreateRoom() {
  yield takeEvery(roomActions.createRoomAsync.request, createRoom);
}
